import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';
const client = axios.create({ baseURL: API_BASE, timeout: 180000 });
client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) { config.headers = config.headers || {}; config.headers.Authorization = `Bearer ${token}`; }
  return config;
});

// Genera el kit de crisis para una situación (llamada a IA, puede tardar).
export async function armarUrgencia(situacion, foco) {
  const { data } = await client.post('/campaign/urgencia', { situacion, foco });
  return data;
}

// Historial de urgencias.
export async function listUrgencias() {
  const { data } = await client.get('/campaign/urgencia');
  return data.urgencias || [];
}

// Una urgencia completa.
export async function getUrgencia(id) {
  const { data } = await client.get('/campaign/urgencia', { params: { id } });
  return data.urgencia;
}

export async function deleteUrgencia(id) {
  await client.delete('/campaign/urgencia', { params: { id } });
}

// Genera (o regenera) el informe político completo de una urgencia (request aparte).
export async function generarInforme(id) {
  const { data } = await client.post('/campaign/urgencia-informe', { id });
  return data.informe; // { secciones: [...] }
}

// Pulso social: serie del índice de reputación + última foto (posts, comentarios, temas).
export async function getPulsoSocial() {
  const { data } = await client.get('/reputation/series');
  return data; // { serie, actual, delta, detalle }
}

// Cobertura de prensa relevante a una situación, barriendo TODA la base
// (media_articles + competitor_news), no solo el snapshot diario.
export async function getUrgenciaPrensa(situacion, dias = 45) {
  const { data } = await client.get('/campaign/urgencia-prensa', { params: { situacion, dias } });
  return data; // { keywords, total, medios, items, por_medio }
}

// Chatea con la IA para ajustar/crear/modificar módulos e informe de una urgencia.
export async function chatUrgencia(id, mensaje) {
  const { data } = await client.post('/campaign/urgencia-chat', { id, mensaje });
  return data; // { reply, cambios, modulos, informe, chat }
}
